import { Component, Host, h, Element } from '@stencil/core';

@Component({
    tag: 'sew-ws-sectors-item',
    styleUrl: 'sew-ws-sectors-item.scss',
    shadow: true,
})
export class SewWsSectorsItem {
    @Element() public host: HTMLSewWsSectorsItemElement;

    private linkEl: HTMLAnchorElement | undefined;

    private triggerLinkClick = () => {
        this.linkEl?.click();
    };

    componentWillLoad() {
        this.linkEl = this.host.querySelector('a');
    }

    render() {
        return (
            <Host onClick={this.triggerLinkClick} class={{ 'no-link': !this.linkEl }}>
                <slot name="image" />
                {this.linkEl && (
                    <div class="link">
                        <sew-icon icon="arrow-right" size="l" />
                        <slot />
                    </div>
                )}
            </Host>
        );
    }
}
